import {processApiRequest} from "../../Common/saga";
import * as ACTION from "../constants";
import apiService from "../apiService";
import {notification} from "antd";
import {t} from "../../../system/i18n";
import {router} from "../../../system/routing";

export function* updateWarehouse(action) {
	yield processApiRequest(ACTION.UPDATE_WAREHOUSE, () => apiService.updateWarehouse(action.payload), action.payload);
}

export function* updateWarehouseSuccess() {
	yield notification.success({message: t('config:message.update_warehouse_success')});
	router.redirect("/config/warehouse/");
}
